import { Routes } from "@angular/router";
import { DashboardComponent } from "../../dashboard/dashboard.component";
import { UserProfileComponent } from "../../user-profile/user-profile.component";
import { TableListComponent } from "../../table-list/table-list.component";
import { TypographyComponent } from "../../typography/typography.component";
import { NotificationsComponent } from "../../notifications/notifications.component";
import { UpgradeComponent } from "../../upgrade/upgrade.component";
import { AdminLayoutComponent } from "./admin-layout.component";
import { OpdVisitsComponent } from "app/opdvisits/opdvisits.component";
import { AuthGuard } from "app/auth/auth-guard.service";
import { DoctorDashboardComponent } from "app/Doctor-Dashboard/doctor-dashboard/doctor-dashboard.component";
import { IpdRegistrationComponent } from "app/ipd/ipd-registration/ipd-registration.component";
import { DentalEmrComponent } from "app/Dental-Emr/Dental-Emr.component";
import { otListComponent } from "app/ipd/ot-list/ot-list.component";
import { SqlChatbotComponent } from "app/sql-chatbot/sql-chatbot.component";
import { AiStoreInsightsComponent } from "app/shared/ai-store-insights/ai-store-insights.component";
import { AiStoreCockpitComponent } from "app/shared/ai-store-cockpit/ai-store-cockpit.component";
import { EyeVisionLabComponent } from "app/shared/eye-vision-lab/eye-vision-lab.component";

export const AdminLayoutRoutes: Routes = [
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      { path: "", component: DashboardComponent },
      { path: "dashboard", component: DashboardComponent },
      { path: "user-profile", component: UserProfileComponent },
      { path: "Registration", component: TableListComponent },
      { path: "table-list/:flag", component: TableListComponent },
      { path: "icons", component: TypographyComponent },
      { path: "OpdVisit", component: OpdVisitsComponent },
      { path: "OpdVisit/:flag", component: OpdVisitsComponent },
      { path: "Receipts", component: NotificationsComponent },
      { path: "Appointments", component: UpgradeComponent },
      { path: "ipd", component: IpdRegistrationComponent },
      { path: "doctor-dashboard", component: DoctorDashboardComponent },
      {
        path: "EMR",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../../EMR/emr.module").then((m) => m.EmrModule),
      },
      {
        path: "DentalEmr",
        component: DentalEmrComponent,
        //canActivate: [AuthGuard],
        // loadChildren: () =>
        //   import("../../Dental-Emr/Dental-Emr.module").then(
        //     (m) => m.DentalEmrModule
        //   ),
      },
      {
        path: "dashboard",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../../dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: "reports",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../../reports/reports.module").then((m) => m.ReportsModule),
      },

      {
        path: "ipd-dashboard",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../../ipd/ipd.module").then((m) => m.IpdModule),
      },
      {
        path: "Billing",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./../../billing/billing.module").then((m) => m.BillingModule),
      },

      // {
      //   path: 'doctorworkup', canActivate: [AuthGuard],
      //   loadChildren: () => import('./../../doctorworkup/doctorworkup.module').then(m => m.DoctorworkupModule)
      // },
      {
        path: "masters",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../../masters/masters.module").then((m) => m.MastersModule),
      },
      {
        path: "labentry",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../../labentry/labentry.module").then((m) => m.LabEntryModule),
      },
      {path:'otlist',component:otListComponent},
      {
        path: "sql-assistant",
        component: SqlChatbotComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "ai-store-insights",
        component: AiStoreInsightsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "store-cockpit",
        component: AiStoreCockpitComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "vision-lab",
        component: EyeVisionLabComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];
